import { CONFIRM_SC_CARE_SESSION, DECLINE_SC_CARE_SESSION } from '@/graphql/backup_care/mutations';

export const confirmSession = async (apollo: any, contractUuid: string): Promise<void> => {
  try {
    await apollo.mutate({
      mutation: CONFIRM_SC_CARE_SESSION,
      variables: {
        contractUuid,
      },
    });
  } catch (error) {
    console.error('Error confirming session:', error);
    throw error;
  }
};

export const declineSession = async (apollo: any, contractUuid: string): Promise<void> => {
  try {
    await apollo.mutate({
      mutation: DECLINE_SC_CARE_SESSION,
      variables: {
        contractUuid,
      },
    });
  } catch (error) {
    console.error('Error declining session:', error);
    throw error;
  }
};

export const isConfirmed = (node: any): boolean => {
  const { kind, scCareSession } = node;
  return kind === 'booking' && ['success', 'rejected'].includes(scCareSession?.careGiverValidationStatus);
};

export const isPendingCareSession = (node: any): boolean => {
  return node.scCareSession?.careGiverValidationStatus === 'pending';
};

export const getCareSessionStatus = (node: any): string | null => {
  return node.scCareSession?.careGiverValidationStatus || null;
};

export const isInProgressCareSession = (node: any): boolean => {
  if (!node.scCareSession?.individualCareRecipientDetails) {
    return false;
  }

  const details = node.scCareSession.individualCareRecipientDetails.filter((recipient: any) => recipient.status === 'InProgress');

  return details.length > 0;
};
